exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tlHeader[data-v-3a08ebf4] {\n  box-sizing: border-box;\n  text-align: center;\n  letter-spacing: normal;\n\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  border-bottom-color: black;\n\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-left-color: #aaaaaa;\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-right-color: #aaaaaa;\n\n  background-color: white;\n}\n.tlHeaderText[data-v-3a08ebf4] {\n  margin: auto;\n  white-space: pre;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3a08ebf4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/TimelineHeader.vue
// module id = 496
// module chunks = 0